module.exports = __webpack_public_path__ + "components/country-flag/static/pr-06603522fe8d25ad5a20a045e17c2b15.svg";